import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import { useHistory } from "react-router";
import getTourById from "../requests/getTourById";
import addUserToTour from "../requests/addUserToTour";
import TourUsersTable from "./TourUsersTable";
import TourUsersForm from "./TourUsersForm";
import getUserByEmail from "../requests/getUserByEmail";

const TourUsers = () => {

  const { tourId } = useParams();
  const initialState = {
    tour: {
      name: "Tour details are loading...",
      users: [],
      editors: [],
      owners: []
    },
    userFields: {
      email: "",
      role: "editor"
    },
    alert: {
      message: "",
      isSuccess: false,
    }
  }

  const history = useHistory();
  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ tour, setTour ] = useState(initialState.tour);
  const [ owners, setOwners ] = useState(initialState.tour.owners);
  const [ editors, setEditors ] = useState(initialState.tour.editors);
  const [ users, setUsers ] = useState(initialState.tour.users);
  const [ userFields, setUserFields ] = useState(initialState.userFields);
  const [ alert, setAlert ] = useState(initialState.alert);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
          // console.log("JWT:", token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user]);

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        if (response.status === 200) {
          setTour(response.data[0]);
          setOwners(response.data[0].owners);
          setEditors(response.data[0].editors);
          setUsers(response.data[0].users);
          // console.log(tour);
        }
      })
    }
  }, [history, token, tourId]);

  const handleUserFieldChange = (event) => {
    setUserFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value
      }
    });
  };

  const handleAddUserRole = (event) => {
    event.preventDefault();
    if (token) {
      getUserByEmail(token, userFields.email).then(response => {
        if (response.status === 200) {
          const userId = response.data[0]._id;
          addUserToTour(token, tourId, userFields.role, userId).then(response => {
            if (response.status === 200) {
              userFields.role === "owner" && setOwners((prev) => [...prev, userId]);
              userFields.role === "editor" && setEditors((prev) => [...prev, userId]);
              setUsers((prev) => [...prev, userId]);
            }
          })
        } else {
          setAlert({
            message: "We don't have an account with that email address. Please confirm that the other user has signed up."
          });
        }
      })
    }
  };

  return (
    <div className="container userRoles">
      <Link to="/" className="nav-link">All tours</Link>
      <h2 className="heading">{tour.name}: Users</h2>

      <section>
        <TourUsersTable token={token} tourId={tourId} users={owners} role="owners"  />
      </section>

      <section>
        <TourUsersTable token={token} tourId={tourId} users={editors} role="editors" />
      </section>

      <section>
        <TourUsersTable token={token} tourId={tourId} users={users} role="viewers" />
      </section>

      <TourUsersForm
        handleUserFieldChange={handleUserFieldChange}
        handleAddUserRole={handleAddUserRole}
        userFields={userFields}
        alert={alert}
      />
    </div>
  )

};

export default TourUsers;